import React from 'react';
import { useTranslation } from 'react-i18next';

import { WebModal } from '@components/Modals/WebModal.web';
import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';

interface CancelInviteMemberConfirmModalProps {
  showModal: boolean;
  onClose?: () => void;
  onPress: () => void;
  buttonText: string;
  title: string;
  message: string | JSX.Element;
  memberName: string;
  isAlert?: boolean;
  cancelButtonText?: string;
  isLoading?: boolean;
}

export const CancelInviteMemberConfirmModal: React.FC<
  CancelInviteMemberConfirmModalProps
> = ({
  showModal,
  onClose,
  onPress,
  buttonText,
  title,
  message,
  memberName = '',
  isAlert = false,
  cancelButtonText = '',
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <WebModal
      marginHorizontal='l'
      title={title}
      onClose={onClose}
      closeDisabled={isLoading}
      visible={showModal}
      width={483}
      height={message !== '' ? 184 : undefined}>
      <>
        <Box flexDirection='row' marginHorizontal='l' marginVertical='l'>
          {message !== '' && (
            <Text variant='webBody' lineHeight={20}>
              {message}
              {memberName !== '' && (
                <Text variant='webBody' fontWeight='bold'>
                  {memberName}
                </Text>
              )}
              .
            </Text>
          )}
        </Box>
        <Box
          flexDirection='row'
          flex={1}
          alignItems='flex-end'
          paddingHorizontal='l'
          mb='l'
          mt='l'
          alignSelf='flex-end'>
          {!isAlert && (
            <Button
              marginRight='m'
              onPress={onClose}
              borderColor='textPrimary'
              isSmall
              disabled={isLoading}
              backgroundColor='white'>
              <Text variant='buttonLabel' color='textPrimary'>
                {cancelButtonText ? cancelButtonText : t('shared:cancel')}
              </Text>
            </Button>
          )}
          <Button
            onPress={onPress}
            borderColor='textPrimary'
            isSmall
            width={125}
            backgroundColor='black'
            isLoading={isLoading}>
            <Text variant='labelSmall' lineHeight={16} color='white'>
              {buttonText}
            </Text>
          </Button>
        </Box>
      </>
    </WebModal>
  );
};
